export const FAUCET_RADIUS: number = 4;
export const FAUCET_BETWEEN_WIDTH: number = 10;

export enum Start {
    CENTER = "CENTER",
    LEFT = "LEFT",
    RIGHT = "RIGHT"
}